import { DetailedInsight } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { InsightCardDetails } from '~/components/insight-card-details/InsightCardDetails';
import { useGetSubscription } from '~/react-query-hooks/events/use-event-alerts/useGetSubscription';
import { useFlags } from '~/stores/use-flags/useFlags';
import { useSubscription } from '~/stores/use-subscription/useSubscription';

import styles from './InsightSummary.module.scss';
import { TrackScenarioInsightButton } from './track-scenario-insight-button/TrackScenarioInsightButton';

export interface InsightSummaryProps {
  insight: DetailedInsight;
  isFixedIncome: boolean;
}

export const InsightSummary = ({
  insight,
  isFixedIncome,
}: InsightSummaryProps) => {
  const { t } = useTranslation('insights');
  const isBasicOrLightUser = useSubscription(state =>
    state.isBasicOrLightUser()
  );
  const { isAlertsFlagEnabled } = useFlags(state => ({
    isAlertsFlagEnabled: state.getFeatureFlagState('alerts'),
  }));
  const isAlertsEnabled = isAlertsFlagEnabled && !isBasicOrLightUser;
  const { data: subscription } = useGetSubscription(
    insight.id,
    'scenario-insight',
    isAlertsEnabled
  );

  return (
    <>
      {isAlertsEnabled ? (
        <div
          className={styles.insightSummaryRoot}
          data-testid="insight-summary"
        >
          <div className={styles.titleRow}>
            <div className={styles.title}>
              {t('insights:drawer.insightAlert')}
            </div>
            {isAlertsEnabled && (
              <TrackScenarioInsightButton
                insightId={insight.id}
                subscription={subscription}
              />
            )}
          </div>
          <div className={styles.insightCardWrapper}>
            <InsightCardDetails
              qualityStars={insight.metadata.stars}
              median={insight.metadata.median_return}
              horizon={insight.metadata.horizon}
              isFixedIncome={isFixedIncome}
            />
          </div>
          {isAlertsEnabled && subscription && (
            <div className={styles.footerText}>
              {t('insights:drawer.insightWillBeTracked')}
            </div>
          )}
        </div>
      ) : (
        <div className={styles.insightCardWrapper}>
          <InsightCardDetails
            qualityStars={insight.metadata.stars}
            median={insight.metadata.median_return}
            horizon={insight.metadata.horizon}
            isFixedIncome={isFixedIncome}
          />
        </div>
      )}
    </>
  );
};
